module.exports = __webpack_public_path__ + "static/media/badge_share_1.b9a55fba.png";


//////////////////
// WEBPACK FOOTER
// ./src/icons/badges/badge_share_1.png
// module id = 494
// module chunks = 0